<template>
  <div class="main" id="app">
    <Affix ref="tab" class="head-affix">
      <div v-if="browser.mobile&&browser.ios" class="ipone"></div>
      <div :class="'headers-background-'+titleInfo.bg" class="head-box">
        <div>
          <Icon @click="back" class="icon" type="ios-arrow-back" />
        </div>
        <div class="title">{{titleInfo.title}}</div>
        <div @click="share" class="more">
          <Icon type="md-share" />
          <span>分享</span>
        </div>
        <!-- <Dropdown @on-click="clickDropdownMenu" trigger="click" class="more">
          <span>
            更多
            <Icon type="ios-arrow-down"></Icon>
          </span>
          <DropdownMenu slot="list">
            <DropdownItem name="share">分享</DropdownItem>
          </DropdownMenu>
        </Dropdown>-->
      </div>
    </Affix>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import * as dd from "dingtalk-jsapi";
import { mapState, mapMutations } from "vuex";
import http from "@/utils/http";
const { dingdingAccessKey } = require(`@/config/develop.json`);
const { menuItem } = require(`@/config/develop.json`);
export default {
  data() {
    return {
      browser: {}
    };
  },
  computed: {
    ...mapState({
      titleInfo: state => state.titleInfo,
      dingdingconfig: state => state.dingdingconfig,
      userInfo: state => state.userInfo,
      historyPageName: state => state.historyPageName
    })
  },
  watch: {
    titleInfo(val) {
      document.title = val.title;
    }
  },
  created() {
    dd.ui.webViewBounce.disable();
    //this.title = document.title;
    var u = navigator.userAgent;
    var browser = {
      versions: (function() {
        var app = navigator.appVersion;
        return {
          //移动终端浏览器版本信息
          trident: u.indexOf("Trident") > -1, //IE内核
          presto: u.indexOf("Presto") > -1, //opera内核
          webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
          gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
          mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
          iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
          iPad: u.indexOf("iPad") > -1, //是否iPad
          webApp: u.indexOf("Safari") == -1 //是否web应用程序，没有头部与底部
        };
      })(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    this.browser = browser.versions;
    this.setBrowser(browser.versions);
  },
  methods: {
    ...mapMutations(["setBrowser"]),
    clickDropdownMenu(name) {
      this.$options.methods[name]();
    },
    back() {
      if (
        (this.browser.mobile &&
          this.$router.history.current.name == this.historyPageName) ||
        this.$router.history.current.name == "errors"
      ) {
        if (this.$router.history.current.name == "errors") {
          dd.biz.navigation.close({
            onSuccess: function(result) {},
            onFail: function(err) {}
          });
        } else {
          dd.biz.navigation.goBack({
            onSuccess: function(result) {},
            onFail: function(err) {}
          });
        }
      } else {
        this.$router.go(-1); //返回上一层
      }
    },
    share() {
      let _this = this;
      dd.biz.chat.pickConversation({
        corpId: _this.dingdingconfig.corpId, //企业id,必须是用户所属的企业的corpid
        isConfirm: "false", //是否弹出确认窗口，默认为true
        onSuccess: function(res) {
          console.log(res);
          _this.sendShareMsg(res.cid);
        },
        onFail: function() {}
      });
    },
    getUrlParam(item) {
      var sValue = location.search.match(
        new RegExp("[?&]" + item + "=([^&]*)(&?)", "i")
      );
      return sValue ? sValue[1] : sValue;
    },
    sendShareMsg(cid) {      
      let applyTypeId = this.getUrlParam("applyTypeId");
      let applyId = this.getUrlParam("applyId");
      let param = {
        sender: this.userInfo.dingTalkID,
        applyId: applyId,
        applyTypeId: applyTypeId,
        dingdingAccessKey: dingdingAccessKey,
        cid: cid
      };
      console.log(param)
      var url = menuItem[applyTypeId];
      http({
        method: "post",
        url: `/api${url}/Apply_Share`,
        data: param
      }).then(res => {});
    }
  }
};
</script>
<style>
.headers-background-SUBMIT {
  background: #feaf0d !important;
  color: #fff;
}
.headers-background-APPRYES {
  background: #5acf32 !important;
  color: #fff;
}
.headers-background-APPRNO {
  background: #fd5020 !important;
  color: #fff;
}
.headers-background-default {
  background: #ffffff !important;
  color: #515a6e;
}
</style>
<style lang="less">
.main {
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: visible;
  letter-spacing: 0.026667rem;
  .head-affix {
    width: 100%;
    border: 0;
    .ipone {
      height: 0.666667rem;
      background: #fff;
      z-index: 99999;
    }
    .head-box {
      margin: 0;
      border: 0;
      padding: 0.4rem;
      line-height: 0.48rem;
      display: flex;
      justify-content: space-between;
      .icon {
        font-size: 0.56rem;
      }
      .title {
        text-align: center;
        font-size: 0.48rem;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .more {
        text-align: center;
        font-size: 0.4rem;
        position: relative;
      }
    }
  }
  .content {
    border: 0;
    flex: 1;
    width: 100%;
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue